import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import i18n from '@/i18n'
import { getGenerateTags } from '@/api'
import { RecipeTag, TempRecipeIngredient } from '@/api/types'
import { Tag, TagGroup } from '@/components/TagGroup'

type Props = {
  diets: RecipeTag[]
  recipeDiets: RecipeTag[]
  selectedDiets: string[]
  onChange?: (tags: string[]) => void
  isDisabled?: boolean
}

const DietOptions = i18n.t('recipe.dietOptions', { returnObjects: true })
type DietTypes = keyof typeof DietOptions

export default function DietEditor({
  diets,
  recipeDiets = [],
  selectedDiets = [],
  isDisabled,
  onChange,
}: Props) {
  const { t } = useTranslation()

  const dietKeys = recipeDiets.map((diet) => diet.name)
  const [selectedKeys, setSelectedKeys] = useState<Set<string>>(new Set(dietKeys))

  const handleTagSelection = (selection: Set<string>) => {
    if (isDisabled) {
      return
    }
    setSelectedKeys(selection)
    onChange && onChange([...selection])
  }

  return (
    <TagGroup
      label={t('recipe.diet')}
      selectionMode="multiple"
      items={diets}
      disallowEmptySelection
      disabledKeys={isDisabled ? diets.map((d) => d.name) : []}
      selectedKeys={[...new Set([...selectedDiets, ...selectedKeys])]}
      onSelectionChange={handleTagSelection}>
      {(item) => <Tag id={item.name}>{t(`recipe.dietOptions.${item.name as DietTypes}`)}</Tag>}
    </TagGroup>
  )
}
